export default __webpack_public_path__ + "static/coins-stacked-013162b92a894390fdfc346fa1116845.svg";